<template>
    <div>
        <b-row>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                <b-row align-v="center">
                  <b-col cols="4" sm="4"	md="4"	lg="4"	xl="2" class="text-right">
                    <label>Operacion</label>
                  </b-col>
                  <b-col cols="8" sm="8"	md="8"	lg="8"	xl="8">
                    <select class="form-control input-placedark input-dark" v-model="tipoOperacion">
                      <option v-for="item in listadeoperaciones" :value="item" :key="item.codigo">{{ item.descripcion }}</option>
                    </select>
                  </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                <b-row class="text-center">
                  <b-col cols="4"	sm="4"	md="4"	lg="4"	xl="12"></b-col>
                  <b-col cols="8"	sm="8"	md="8"	lg="8"	xl="12">
                    <datepicker v-model="femision" :format="customFormatter" :language="es" :bootstrap-styling="true" :disabledDates="diasnopermitidos" :placeholder="currentdate"></datepicker>
                  </b-col>
                </b-row>
              </b-col>
        </b-row><hr>
        <b-row>
            <b-col xl="2">
                <b-form-input type="text" class="form-control address" v-model="receptor.numero" placeholder="RUC" autofocus @change="getReceivers()"></b-form-input>
                <template v-if="cargandoreceptor">
                <b-list-group class="searcher-field">
                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                </b-list-group>
                </template>
                <b-list-group v-if="listarec" class="searcher-field">
                <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                    <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                    {{item.idReceptor + ' - ' + item.razonSocial}}
                    </b-list-group-item>
                </template>
                </b-list-group>
            </b-col>
            <b-col xl="3">
                <b-form-input type="text" class="form-control address" @input="pitcherReceiver()" v-model="receptor.razonSocial" placeholder="Razon Social" autofocus></b-form-input>   
            </b-col>
            <b-col xl="4">
                <b-form-input type="text" class="form-control address" v-model="receptor.direccion" placeholder="Dirección" autofocus></b-form-input>
            </b-col>
            <b-col xl="1">
                <datepicker v-model="femision" :format="customFormatter" :language="es" :bootstrap-styling="true" :disabledDates="diasnopermitidos" :placeholder="currentdate"></datepicker>
            </b-col>
            <b-col xl="1">
                <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="moneda">
                    <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                    {{ moneda.descripcion }}
                    </option>
                </select>
            </b-col>
            <b-col xl="1">
                <b-input-group>
                    <template v-if="seriesCargadas">
                    <b-button size="md" variant="secondary" outline-success>
                        Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                    </template>
                    <template v-else>
                    <select class="form-control input-placedark input-dark" v-model="indexSerie">
                        <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                    </select>
                    </template>
                </b-input-group>
            </b-col>
        </b-row><br>
        <template v-if="comprobantes">
            <b-row>
                <b-col xl="2">
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                </b-col>
                <b-col xl="1">
                    <div class="mt-2">
                        Desde:     
                    </div>
                </b-col>
                <b-col xl="2">
                    <datepicker v-model="f1" :language="es" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                </b-col>
                <b-col xl="1">
                    <div class="mt-2">
                        Hasta:     
                    </div>
                </b-col>
                <b-col xl="2">
                    <datepicker v-model="f2" :language="es" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                </b-col>
            </b-row><br>
            <b-row>
                <b-col xl="7">
                    <b-row>
                        <b-col>
                            <b-table
                                small
                                :items="vouchers"
                                :fields="vouchers_fields"
                                :current-page="pactual"
                                :per-page="limite"
                                :busy="loading"
                                >
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong> Cargando...</strong>
                                </div>
                                <template slot="emision" slot-scope="row">
                                    {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }}
                                </template>
                                <template slot="importe" slot-scope="row">
                                    <div class="text-right">
                                        <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
                                        <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
                                        <template v-else>{{ row.item.tipoMoneda }}</template>
                                        {{row.item.importeTotal}}
                                    </div>
                                </template>
                                <template slot="acciones" slot-scope="row"> 
                                    <div class="text-right">
                                        <b-form-checkbox v-model="row.item.add" @change="preItem(row.item, row.index)"></b-form-checkbox>                                    
                                    </div>                                   
                                </template>
                            </b-table>
                            <b-card-text v-if="!loading && vouchers.length==0" class="text-muted text-center mt-4">No se encontraron resultados</b-card-text>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                        </b-col>
                        <b-col>
                            <div class="float-right">
                                <b-pagination
                                    size="sm"
                                    :total-rows="total"
                                    v-model="currentPage"
                                    @input="listVouchers(1)"
                                    :per-page="limite"
                                ></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col xl="5">
                    <div class="linea">
                        <b-table
                            class="ml-4"
                            small
                            :items="items"
                            :fields="items_fields"
                            >
                            <template slot="percibido" slot-scope="row">
                            {{row.item.importePercibido}}
                            </template>
                            <template slot="cobrado" slot-scope="row">
                                {{row.item.montoTotalCobrado}}
                            </template>
                            <template slot="acciones" slot-scope="row">
                                <b-button size="sm" variant="ligth" @click="removeItem(row.item, row.index)"><i class="fa fa-trash text-danger"></i></b-button>
                            </template>
                        </b-table>
                        <b-row class="ml-2">
                            <b-col xl="6">
                                Total Percibido: <b>{{ accumulateImportePercibido() }}</b>
                            </b-col>
                            <b-col xl="6">
                                Total Cobrado: <b>{{ accumulateTotalCobrado() }}</b>
                            </b-col>
                        </b-row>
                        <b-row class="ml-2">
                            <b-col xl="12">
                                <b-form-textarea
                                    class="mt-2"
                                    v-model="observaciones"
                                    placeholder="Observaciones..."
                                    rows="3"
                                ></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col xl="10">
                                <div class="mt-4 text-right">
                                    <b-button v-if="!loadingVoucher" :disabled="validateVoucher()" size="sm" variant="primary" @click="sendVoucher()"><i class="fa fa-location-arrow"></i> Emitir</b-button>
                                    <b-button v-else size="sm" variant="secondary"><i class="fa fa-spin fa-spinner"></i> Emitiendo</b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row><br>
        </template>
        <b-modal id="datapercepcion" title="Datos de la percepción" size="lg" v-model="modalpercepcion" >
            <b-alert show variant="warning" class="p-0 pl-5">
                <b-row>
                    <b-col>
                        <b>Documento</b> 
                    </b-col>
                    <b-col>
                        <b>Fecha de emitido</b>
                    </b-col>
                    <b-col>
                        <b>Deuda total</b>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{ itemSelected.serie }} - {{ itemSelected.numero }}
                    </b-col>
                    <b-col>
                        {{ itemSelected.fechaEmisionDocumentoRelacionado }}
                    </b-col>
                    <b-col>    
                        <template v-if="itemSelected.tipoMonedaDocumentoRelacionado=='PEN'">S/</template>
                        <template v-else-if="itemSelected.tipoMonedaDocumentoRelacionado=='USD'">$</template>
                        <template v-else>{{ itemSelected.tipoMonedaDocumentoRelacionado }}</template>
                        {{totalxCobrar}}
                    </b-col>
                </b-row>
            </b-alert>
            <b-row>
                <b-col xl="6">
                    Importe total a percibir: <b>S/ {{ importepercibido }}</b>
                    <b-card-text class="small text-muted">Aplicando el {{ tipoOperacion.porcentaje }}% del importe total, según normativa de SUNAT</b-card-text>
                </b-col>
                <b-col xl="3">
                    Como realizara el pago: 
                </b-col>
                <b-col xl="3">
                    <b-form-radio-group
                        v-model="tipopago"
                        :options="opciones"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                    ></b-form-radio-group>
                </b-col>
            </b-row><br>
            <b-row class="ml-4">
                <b-col xl="5" class="mt-2">
                    Fecha de cobro (Doc. Relacionado)
                </b-col>
                <b-col xl="3">
                    <datepicker v-model="fechaCobroDocumentoRelacionado" :language="es" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                </b-col>
            </b-row><br>
            <b-row class="ml-4">
                <b-col xl="2" class="mt-2 mr-0">
                    Nº de Pago
                </b-col>
                <b-col xl="2">
                    <b-form-input v-model="numeroCobroDocumentoRelacionado" placeholder="Nº Pago"></b-form-input>
                </b-col>
                <b-col xl="1"></b-col>
                <b-col xl="3" class="mt-2">
                    Monto Cobrado
                </b-col>
                <b-col xl="2">
                    <b-form-input v-model="importeCobroDocumentoRelacionado" placeholder="Total cobrado"></b-form-input>
                </b-col>
            </b-row><br>
            <b-row class="ml-4">
                <b-col xl="5" class="mt-2">
                    Fecha de Percepcion (Doc. Relacionado)
                </b-col>
                <b-col xl="3">
                    <datepicker v-model="fechaPercepcionDocumentoRelacionado" :language="es" :bootstrap-styling="true" :placeholder="currentdate"></datepicker>
                </b-col>
            </b-row>
            <div slot="modal-footer" class="w-100 text-right">
                <b-button v-if="!saving" size="sm" variant="primary" @click="addItem()"><i class="fa fa-plus"></i> Guardar</b-button>
                <b-button v-else size="sm" variant="secondary"><i class="fa fa-spin fa-spinner"></i> Guardando...</b-button>
            </div>
        </b-modal>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import { TipoMoneda } from '@/shared/utils'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { ListaOperacionP } from '@/shared/utils'
import axios from 'axios'
    export default {
        name: 'PercepcionEmision',
        components: {Datepicker},
        data: () => {
            return {
                femision: '',
                loadingVoucher: false,
                importepercibido: '',
                numeroCobroDocumentoRelacionado: 1,
                importeCobroDocumentoRelacionado: 0,
                fechaPercepcionDocumentoRelacionado: '',
                fechaCobroDocumentoRelacionado: '',
                tipopago: '1',
                totalxCobrar: '',
                opciones: [
                    { item: '1', name: 'Total' },
                    { item: '2', name: 'Parcial' }
                ],
                monedaExtrangera: '',
                montoTotalCobrado: '',
                tipocambio: '',
                fechaTipoCambio: '',
                saving: false,
                modalpercepcion: false,
                tipoOperacion: {
                    codigo: "01",
                    descripcion: "Percepción Venta Interna",
                    porcentaje: '2.00'
                },
                listadeoperaciones: ListaOperacionP,
                diasnopermitidos: {
                    ranges: []
                },
                selected: 1,
                options: [
                    { value: 1, text: '(F) Facturas' },
                    { value: 2, text: '(B) Boletas' }
                ],
                items: [],
                items_fields: [
                    { key: "serie", label: "Serie", sorteable: true },
                    { key: "numero", label: "Numero", sorteable: true },
                    { key: "percibido", label: "M. Percibido", sorteable: true },
                    { key: "cobrado", label: "M. Cobrado", sorteable: true },
                    { key: "acciones", label: "Acciones" }
                ],
                loading: false,
                comprobantes: false,
                status: false,
                receptor: {
                    numero:'',
                    tipo:'6',
                    razonSocial:'',
                    direccion:'',
                },
                cargandoreceptor: false,
                listarec: true,
                listaReceptores: [],
                moneda: {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                seriesCargadas: false,
                indexSerie: 0,
                listaSeries: ['PERC','PE01'],
                tipoMoneda: TipoMoneda,
                vouchers: [],
                vouchers_fields: [
                    { key: "serie", label: "Serie", sortable: true },
                    { key: "numero", label: "Numero", sortable: true },
                    { key: "emision", label: "Emisión", sortable: true },
                    { key: "importe", label: "Total Venta", sortable: true },
                    { key: "acciones", label: "Añadir" }
                ],
                cargando: false,
                f1: '',
                f2: '',
                currentPage: 1,
                limite: 10,
                orden: 'desc',
                totalRows: null,
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                currentdate: '',
                es: es,
                pactual: 1,
                codigoRegimenPercepcion: "01",
                porcentajePercepcion: "2.00",
                observaciones: "",
                importeTotalPercibido: 9,
                monedaTotalPercibido: "PEN",
                importeTotalCobrado: 0,
                monedaTotalCobrado: "PEN",
                montoRedondeoCobrado: 0,
                itemSelected: {},
                indexSelected: 0
            }
        },
        mounted() {
            this.initDates()
            // this.getSeries()
        },
        watch: {
            fechaCobroDocumentoRelacionado: function () {
                if(this.fechaCobroDocumentoRelacionado==''){
                    this.itemSelected.fechaCobroDocumentoRelacionado = this.$moment().format('YYYY-MM-DD')
                }else{
                    this.itemSelected.fechaCobroDocumentoRelacionado = this.$moment(this.fechaCobroDocumentoRelacionado).format('YYYY-MM-DD')
                }
            },
            fechaPercepcionDocumentoRelacionado: function () {
                if(this.fechaPercepcionDocumentoRelacionado==''){
                    this.itemSelected.fechaPercepcionDocumentoRelacionado = this.$moment().format('YYYY-MM-DD')
                }else{
                    this.itemSelected.fechaPercepcionDocumentoRelacionado = this.$moment(this.fechaPercepcionDocumentoRelacionado).format('YYYY-MM-DD')
                }
            },
            modalpercepcion: function () {
                let bandera = false
                let index = this.indexSelected
                if(this.modalpercepcion==false){
                    this.items.forEach(function (element) {
                        if(element.indexprincipal==index){
                            bandera = true
                        }
                    })
                    if(!bandera){
                        this.itemSelected = {}
                        this.vouchers[index].add = false
                    }
                }
            },
            tipopago: function () {
                if(this.tipopago=='1') {
                    this.itemSelected.importePercibido = (parseFloat(this.tipoOperacion.porcentaje)*this.itemSelected.importeCobroDocumentoRelacionado)/100
                    this.importepercibido = this.itemSelected.importePercibido
                    this.importeCobroDocumentoRelacionado = this.itemSelected.importeTotalDocumentoRelacionado
                }else if(this.tipopago=='2') {
                    this.importepercibido = 0
                    this.importeCobroDocumentoRelacionado = 0
                }
            },
            numeroCobroDocumentoRelacionado: function () {
                this.itemSelected.numeroCobroDocumentoRelacionado = this.numeroCobroDocumentoRelacionado
            },  
            importeCobroDocumentoRelacionado: function () {
                this.itemSelected.importeCobroDocumentoRelacionado = this.importeCobroDocumentoRelacionado
                this.itemSelected.importePercibido = (parseFloat(this.tipoOperacion.porcentaje)*this.itemSelected.importeCobroDocumentoRelacionado)/100
                this.importepercibido = this.itemSelected.importePercibido
                this.itemSelected.montoTotalCobrado = parseFloat(this.itemSelected.importeCobroDocumentoRelacionado) + this.itemSelected.importePercibido
            },
            selected: function () {
                if(this.selected==1 && this.receptor.numero.length==11) {
                    this.listVouchers(1)
                }else if(this.selected==2 && this.receptor.numero.length==11){
                    this.listVouchers(2)
                }else {
                    this.$snotify.warning('Asegurese de ingresar el numero de documento!', 'Cuidado')
                }
            },
            'receptor.numero': function () {
                if(this.receptor.numero.length==11){
                    this.comprobantes = true,
                    this.listVouchers(1)
                }
            }
        },
        methods: {
            validateVoucher: function () {
                if(this.items.length>0 && this.receptor.numero!='' && this.receptor.razonSocial!=''){
                    return false
                }else{
                    return true
                }
            },
            preItem: function (item, index) {
                this.modalpercepcion = true
                this.indexSelected = index
                this.importepercibido = (parseFloat(this.tipoOperacion.porcentaje)*item.importeTotal)/100
                this.monedaExtrangera = item.tipoMoneda
                this.itemSelected.add = item.add
                this.itemSelected.indexprincipal = index
                this.itemSelected.serie = item.serie
                this.itemSelected.numero = item.numero
                this.selected==1 ? this.itemSelected.tipoDocumentoRelacionado = '01': this.itemSelected.tipoDocumentoRelacionado = '03'
                this.itemSelected.serieDocumentoRelacionado = item.serie,
                this.itemSelected.numeroDocumentoRelacionado = item.numero,
                this.itemSelected.fechaEmisionDocumentoRelacionado = this.$moment(item.fechaEmision).format('YYYY-MM-DD'),
                this.itemSelected.importeTotalDocumentoRelacionado = item.importeTotal,
                this.itemSelected.tipoMonedaDocumentoRelacionado = item.tipoMoneda,
                this.itemSelected.fechaCobroDocumentoRelacionado = this.$moment().format('YYYY-MM-DD'), // add(1,'days').  this.$moment().subtract(2,'years').startOf('day').format('YYYY-MM-DD HH:mm:ss')
                this.itemSelected.numeroCobroDocumentoRelacionado = 1,
                this.itemSelected.importeCobroDocumentoRelacionado = item.importeTotal,
                this.itemSelected.monedaCobroDocumentoRelacionado = item.tipoMoneda,
                this.itemSelected.importePercibido = this.importepercibido,
                this.itemSelected.monedaImportePercibido = 'PEN',
                this.itemSelected.fechaPercepcionDocumentoRelacionado = this.$moment(item.fechaEmision).format('YYYY-MM-DD'),
                this.itemSelected.montoTotalCobrado = parseFloat(item.importeTotal) + this.itemSelected.importePercibido,
                this.itemSelected.monedaMontoTotalCobrado = 'PEN',
                this.itemSelected.monedaOrigenTipoCambio = this.moneda.codigo,
                this.itemSelected.monedaDestinoTipoCambio = 'PEN',
                this.totalxCobrar = item.importeTotal,
                this.importeCobroDocumentoRelacionado = item.importeTotal
                if(item.tipoMoneda!='PEN'){
                    this.itemSelected.tipoCambio = this.tipocambio
                }else{
                    this.itemSelected.tipoCambio = 1
                }
                if(this.femision == ''){
                    this.itemSelected.fechaTipoCambio = this.$moment().format('YYYY-MM-DD')
                }else{
                    this.itemSelected.fechaTipoCambio = this.femision.format('YYYY-MM-DD')
                }   
                
            },
            sendVoucher: function () {
                this.loadingVoucher = true
                let voucher = {
                    items: [],
                    receptor: {}
                }
                voucher.token = this.$store.getters.userToken
                voucher.serie = this.listaSeries[this.indexSerie]
                voucher.codigoRegimenPercepcion = this.tipoOperacion.codigo
                voucher.porcentajePercepcion = this.tipoOperacion.porcentaje
                if(this.observaciones!=''){
                    voucher.observaciones = this.observaciones
                }
                voucher.importeTotalPercibido = this.importeTotalPercibido
                voucher.monedaTotalPercibido = this.moneda.codigo
                voucher.importeTotalCobrado = this.importeTotalCobrado
                voucher.monedaTotalCobrado = this.moneda.codigo
                voucher.montoRedondeoCobrado = this.montoRedondeoCobrado
                voucher.items = this.items
                voucher.receptor.tipo = this.receptor.tipo
                voucher.receptor.nro = this.receptor.numero
                if(this.femision != ''){
                    voucher.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
                }
                axios
                .post(process.env.VUE_APP_API_URL + 'percepcion/emitir', voucher)
                .then(response => (
                    this.loadingVoucher = false,
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.initVoucher()
                ))
                .catch(error => (  
                    this.loadingVoucher = false,
                    this.$snotify.error(error.response.data.msg,'Error')
                )) 
            },
            initVoucher: function () {
                this.items = []
                this.receptor = {
                    numero:'',
                    tipo:'6',
                    razonSocial:'',
                    direccion:'',
                },
                this.itemSelected = {},
                this.vouchers = {},
                this.comprobantes = false
            },
            accumulateImportePercibido: function () {
                let acumulado = 0.00
                this.items.forEach(function (element) {
                    acumulado += parseFloat(element.importePercibido)
                })
                this.importeTotalPercibido = acumulado
                return this.importeTotalPercibido
            },
            accumulateTotalCobrado: function () {
                let acumulado = 0.00
                this.items.forEach(function (element) {
                    acumulado += parseFloat(element.montoTotalCobrado)
                })
                this.importeTotalCobrado = acumulado
                return this.importeTotalCobrado
            },
            addItem: function () {
                let i = {}
                this.modalpercepcion = false
                if(!this.itemSelected.add){
                    this.items.push(this.itemSelected)
                    this.vouchers[this.itemSelected.indexprincipal].add = true
                    this.itemSelected = {}
                }else if(this.items.length>0 && this.itemSelected.add){
                    this.vouchers[index].add = false
                    this.items.splice(index,1)
                }
            },
            removeItem: function (item, index) {
                this.vouchers[item.indexprincipal].add = false
                this.items.splice(index,1)
            },
            customFormatter: function (date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            },
            listVouchers: function (tipo) {
                this.loading = true
                let date1 = ''
                let date2 = ''
                let querys = []
                let query = {
                    type: 1,
                    name: 'RUC',
                    value: this.receptor.numero
                }
                querys.push(query)
                let ruta = ''
                tipo==1 ? ruta='facturas/reporte': ruta='boletas/reporte'
                if(this.f1 == ''){
                    date1 = this.$moment().subtract(2,'years').startOf('day').format('YYYY-MM-DD HH:mm:ss')
                }
                else
                {
                    date1 = this.$moment(this.f1).startOf('day').format('YYYY-MM-DD HH:mm:ss')
                }
                if(this.f2 == ''){
                    date2 = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                }
                else
                {
                    date2 = this.$moment(this.f2).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                }
                axios
                .post(process.env.VUE_APP_API_URL + ruta, {
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    l: this.limite,
                    order: this.orden,
                    q: querys,
                    f1: date1,
                    f2: date2
                })
                .then(response => (
                    this.asignData(response.data.report)
                ))
                .catch(error => (
                    this.loading = false,
                    this.$snotify.error(error.response.data.response, 'Error')
                ))
            },
            asignData: function (data) {
                let comprobantes = []
                let emitidos = []
                comprobantes = data.data
                comprobantes.forEach(function (element){
                    if(element.emitido == 1 && element.baja == 0){
                        element.add = false,
                        emitidos.push(element)
                    }
                })
                this.vouchers = emitidos,
                this.totalRows = this.vouchers.length,
                this.loading = false,
                this.total = data.total,
                this.desde = data.from,
                this.hasta = data.to
            },
            getSeries: function () {
                this.seriesCargadas = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'usuario/series/1', {
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listaSeries = response.data.data,
                    this.rolSeries = response.data.rol,
                    this.seriesCargadas = false
                ))
                .catch(error => {
                    this.seriesCargadas = false
                })
            },
            validTicket: function () {
                let serie = ''
                let pago = false
                let totalpagado = Math.round(parseFloat(this.pago)*100)/100
                let importe = Math.round(parseFloat(this.totales.importeTotal)*100)/100
                totalpagado>=importe ? pago = true: pago = false
                this.indexSerie==0 ? serie = this.listaSeries[0]: serie = this.listaSeries[this.indexSerie]
                switch(this.selected){
                    case 1: 
                        if(this.receptor.numero != '' && this.receptor.razonSocial != '' && this.items.length > 0 && serie != '' && pago && this.newimpresion){
                            return false
                        }else{
                            return true
                        }
                        break;
                    case 2:
                        if(this.items.length > 0 && serie != '' && pago && this.newimpresion){
                            return false
                        }else{
                            return true
                        }
                        break;
                }
            },
            pitcherReceiver: function () {
                if(this.receptor.razonSocial.length >= 3){
                    setTimeout(() => this.getReceiversByRSocial(), 200);
                }else if(this.receptor.razonSocial.length <= 2){
                    this.initReceptor()
                }  
            },
            initReceptor: function () {
                this.receptor = {
                    numero:'',
                    tipo:'6',
                    direccion:'',
                    nombre:'',
                    direccionReferencia: ''
                },
                this.listaReceptores = [],
                this.cargandoreceptor = false
            },
            getReceiversByRSocial: function () {
                if(this.receptor.razonSocial.length>=3){
                    this.cargandoreceptor = true
                    this.listarec = true
                    this.norec = false
                axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista/razonsocial',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.razonSocial,
                })
                .then(response => (
                    this.listaReceptores = response.data.response,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                ))
                .catch(function (error){
                    this.cargandoreceptor = false
                })
                }else{
                this.listaReceptores = [],
                this.cargandoreceptor = false
                }
            },
            receivercount: function (value){
                if(value.length === 0)
                {
                this.$snotify.warning('No se encontró al receptor', 'Atención')
                }
            },
            setReceiver: function (item) {
                this.receptor.numero = item.idReceptor,
                this.receptor.tipo = item.tipo,
                this.receptor.razonSocial = item.razonSocial,
                this.receptor.direccion = item.direccionReferencia,
                this.direcciones = item.direcciones,
                this.listaCorreos = item.email,
                this.listarec = false,
                this.listaReceptores = []
            },
            getReceivers: function () {
                this.cargandoreceptor = true
                if(this.receptor.numero.length >= 3){
                this.stateReceptorRuc(this.receptor.numero)
                this.listarec = true
                this.norec = false
                // lista/razonSocial
                    axios
                    .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.numero,
                    tipoRec: '6'
                    })
                    .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                    ))
                    .catch(error => (
                    this.listaReceptores = [],
                    this.cargandoreceptor = false
                    // this.listarec = true,
                    // this.norec = false
                    ))
                }else if(this.receptor.numero.length === 0){
                    this.listaReceptores = [],
                    this.cargandoreceptor = false
                } 
            },
            stateReceptorRuc (value) {
                let expreg = new RegExp('\\s|<|>|[A-Za-z]|^[3-9]|^[0]')
                if(this.selected == 1){
                    if(value.length == 0){
                        this.rucValid = false
                    } else if (expreg.test(value)) {
                        this.$snotify.error('RUC Inválido','Error');
                        this.rucValid = false
                    } else {        
                        this.rucValid = true       
                    }   
                }
            },
            initDates: function () {
                let r1 = {
                    from: this.$moment().subtract(50000,'years'),
                    to: this.$moment().subtract(4,'days')
                }
                let r2 = {
                    from: this.$moment().add(0,'days'),
                    to: this.$moment().add(60000,'years')
                }
                this.diasnopermitidos.ranges.push(r1)
                this.diasnopermitidos.ranges.push(r2)
                this.currentdate = this.$moment().format('DD-MM-YYYY')
            },
        }
    }
</script>

<style lang="scss" scoped>
.searcher-field{
  z-index: 1000;
  position: absolute;
  max-height: 400px !important;
  overflow-y: scroll;
  width: 500px
}
.searcher-result{
  font-size: smaller;
  padding: 2px 0px 2px 0px;
  cursor: pointer;
}
.linea{
    border-left: 2px solid #ccc;
}
.custom-control {
    position: relative;
    display: block;
    min-height: 1.3125rem;
    padding-left: 0px;
}
</style>